module.exports = __webpack_public_path__ + "static/media/Edit-Select.724a445c.svg";